import { defineMessages } from 'react-intl';

export default defineMessages({
  linkToShippedOrdersReport: {
    defaultMessage: 'See all shipped order data',
    id: 'AiJsWj',
    description: 'link to shipped orders report',
  },
  linkToShipmentsByUserReport: {
    defaultMessage: 'See all shipments by user',
    id: '0uonb4',
    description: 'link to shipments by user report',
  },
  shipments: {
    defaultMessage: 'Shipments',
    id: '65ij9f',
    description: '"Shipments" label',
  },
  shippingRevenue: {
    defaultMessage: 'Shipping Revenue',
    id: 'nBFX2J',
    description: '"Shipping Revenue" label',
  },
  shippingCost: {
    defaultMessage: 'Shipping Cost',
    id: 'yoieff',
    description: '"Shipping Cost" label',
  },
  shippingNetRevenue: {
    defaultMessage: 'Net Shipping Revenue',
    id: 'f5WJXr',
    description: '"Net Shipping Revenue" label',
  },
  averageCostPerLabel: {
    defaultMessage: 'Avg Cost per Label',
    id: '/BMYTu',
    description: '"Average Cost per Label" label where Average is abbreviated',
  },
});
